import axios from "axios";
import { getDecryptedItem, setEncryptedItem } from "./crypto";
import { decodeToken } from "src/libs/jwt";
import Cookies from "js-cookie";

const STORAGE_KEY = "__jlx_AX929423189B";
const PUBLIC_ENDPOINTS = [
  "public/overview",
  "public/prepare",
  "public/thumbnail",
  "auth/login",
];

export const API = axios.create({
  baseURL: process.env.NEXT_PUBLIC_BASE_API,
  withCredentials: true,
});

API.interceptors.request.use(async (config) => {
  const isPublic = PUBLIC_ENDPOINTS.some((endpoint) =>
    config.url.startsWith(endpoint)
  );

  if (!isPublic) {
    const csrfToken = Cookies.get("csrfToken");

    if (csrfToken) {
      config.headers["X-CSRF-Token"] = csrfToken;
    }

    const accessToken = getDecryptedItem(STORAGE_KEY);

    if (accessToken) {
      const payload = decodeToken(accessToken);

      if (payload.isExpired && config.url !== "auth/refresh-token") {
        try {
          const response = await API.post("auth/refresh-token", payload);

          const newToken = response.data.token;
          setEncryptedItem(STORAGE_KEY, newToken);

          config.headers["Authorization"] = "Bearer " + newToken;
        } catch (error) {
          console.error(error);
        }
      }

      if (!payload.isExpired) {
        config.headers["Authorization"] = "Bearer " + accessToken;
      }
    }
  } else {
    const publicToken = Cookies.get("publicToken");

    if (publicToken) {
      config.headers["public-token"] = publicToken;
    }
  }

  return config;
});
